/* eslint-disable react/button-has-type */
import React from 'react';
import PropTypes from 'prop-types';
// import { Modal, Box } from '@material-ui/core';
import { Modal, Box } from '@mui/material';
import DoNotDisturbIcon from '@mui/icons-material/DoNotDisturb';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import styles from './FormComponents.module.css';
import CloseIcon from '@mui/icons-material/Close';
import { Button } from "../../atomicComponents";
import clsx from 'clsx';
import { bulkUploadLimit } from '../../constants/constVariables';
const title2 = {
    errorMessageData: [
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
        {
            name: "name",
            message: "message",
        },
    ]
}
const BulkSearchModal = ({ handleClose, open, downloadBulkCsv, openUploadFile }) => (

    <Modal open={open} onClose={handleClose}>
        <div className={styles.containerSearch}>
            {/* <Box className={styles.searchBoxContainer}> */}
            <div backgroundColor="black">
                <div className={styles.searchMainHeader}>
                    <div style={{ textAlign: "right", padding: "10px 10px 0 0", height: "20px" }}>
                        <CloseIcon className={styles.searchcrossBlock} onClick={handleClose} />
                    </div>
                    <div style={{ textAlign: "center" }}>
                        <>
                            <span style={{ fontSize: "24px", fontWeight: "bold", color: "#4E4E4E" }}>Bulk Search</span>
                        </>
                    </div>
                </div>
                <hr style={{ margin: "16px 0 20px 0" }}></hr>
            </div>
            <div className={styles.searchButtonDiv}>
                <Button
                    variant="primary"
                    onClick={downloadBulkCsv}
                    style={{
                        backgroundColor: "#82C1A7",
                        width: "50%"
                    }}
                // onClick={get}
                >
                    DOWNLOAD TEMPLATE
                </Button>
                <span style={{ padding: "10px" }}>or</span>
                <div className={styles.uploadTemplateContainer}>
                    <Button
                        variant="primary"
                        style={{
                            backgroundColor: "#82C1A7",
                            width: "50%",
                        }}
                        onClick={openUploadFile}
                    >
                        UPLOAD TEMPLATE
                    </Button>
                    <span>*Search upto {bulkUploadLimit} VINs only</span>
                </div>
            </div>


            {/* </Box> */}
        </div>
    </Modal>
);
BulkSearchModal.propTypes = {
    // confirmDelete: PropTypes.func.isRequired,
    open: PropTypes.bool.isRequired,
    handleClose: PropTypes.func.isRequired,
    downloadBulkCsv: PropTypes.func,
    openUploadFile: PropTypes.func
};
export default BulkSearchModal;
